/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Faq_1_AInputs */

const en_mk_faq_1_a = /** @type {(inputs: Mk_Faq_1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can start without coding. Describe your needs on the getting-started page, review the plan, and choose Automatic or Guided. Local mode is for people using their own coding agent and development tools.`)
};

const id_mk_faq_1_a = /** @type {(inputs: Mk_Faq_1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak untuk memulai. Ceritakan kebutuhanmu melalui halaman Mulai, tinjau rencana, lalu pilih Otomatis atau Didampingi. Mode Mandiri ditujukan untuk pengguna yang bekerja dengan agent coding dan alat pengembangan sendiri.`)
};

/**
* | output |
* | --- |
* | "You can start without coding. Describe your needs on the getting-started page, review the plan, and choose Automatic or Guided. Local mode is for people usin..." |
*
* @param {Mk_Faq_1_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_faq_1_a = /** @type {((inputs?: Mk_Faq_1_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Faq_1_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_faq_1_a(inputs)
	return en_mk_faq_1_a(inputs)
});